/* import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler'; */

import { provideHttpClient } from '@angular/common/http';
import {
	type EnvironmentProviders,
	inject,
	provideAppInitializer,
	type Provider
} from '@angular/core';
import { /* provideTranslateCompiler, */ provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import {
	axiosHttpInterceptorBuilder,
	axiosHttpServiceBuilder
} from '@contexts/shared/infrastructure';
import { environmentRepositoryBuilder } from '@contexts/shared/infrastructure/environment/environment.repository';
import { indexedDBStorageRepositoryBuilder } from '@contexts/shared/infrastructure/storage/indexeddb-storage.repository';

import { ENVIRONMENT_REPOSITORY } from '@dependencies/shared';
import {
	GLOBAL_HTTP_CONFIG,
	HTTP_INTERCEPTOR,
	HTTP_SERVICE,
	STORAGE_REPOSITORY
} from '@dependencies/shared/domain/contracts';

import { ThemeService } from '@shared/services/themes.service';

export const commonDependencies: (EnvironmentProviders | Provider)[] = [
	{
		provide: STORAGE_REPOSITORY,
		useFactory: indexedDBStorageRepositoryBuilder
	},
	{
		provide: HTTP_SERVICE,
		useFactory: axiosHttpServiceBuilder,
		deps: [GLOBAL_HTTP_CONFIG]
	},
	{
		provide: ENVIRONMENT_REPOSITORY,
		useFactory: environmentRepositoryBuilder,
		deps: [HTTP_SERVICE]
	},
	provideAppInitializer(() => {
		const envRepository = inject(ENVIRONMENT_REPOSITORY);
		return envRepository.init();
	}),
	{
		provide: HTTP_INTERCEPTOR,
		useFactory: axiosHttpInterceptorBuilder
	}
];

export const themeDependencies: (EnvironmentProviders | Provider)[] = [
	{
		provide: ThemeService,
		deps: [ENVIRONMENT_REPOSITORY]
	}
];

export const translationDependencies: (EnvironmentProviders | Provider)[] = [
	provideHttpClient(),
	provideTranslateService({
		loader: provideTranslateHttpLoader({
			prefix: 'assets/i18n/',
			suffix: '.json'
		}),
		//compiler: provideTranslateCompiler(TranslateMessageFormatCompiler),
		fallbackLang: 'ES',
		lang: 'ES'
	})
];

export * from '@dependencies/shared/domain/contracts';
